import { IEvent } from '@studyportals/event-aggregation-service-interface';
import { ICache } from '@studyportals/search-page-interface';

export class SearchPageCacheReadyEvent implements IEvent {
	public static readonly EventType = 'SearchPageCacheReadyEvent';

	public readonly timestamp = new Date();
	public readonly eventType = SearchPageCacheReadyEvent.EventType;
	public readonly cache: ICache;

	public constructor(cache: ICache) {
		this.cache = cache;
	}

	public static is(event: IEvent): event is SearchPageCacheReadyEvent {
		return event.eventType === SearchPageCacheReadyEvent.EventType;
	}
}
